import { useState } from 'react';
import { getCoverage } from '../product-group-table';
import { ProductInsuranceProps } from '../../shared/types';
import { Chevron, Segments, Title } from '@gjensidige/builders-components';
import type { ProductGroupTableViewProps } from '../types';
import styles from '../product-group-table.module.less';
import classNames from 'classnames';

export const TableMobile = ({
  children,
  features,
  products
}: ProductGroupTableViewProps) => (
  <div className={styles.mobile}>
    <Segments>
      {children}
      <Segments.Tablist
        className={classNames(styles.header, styles.productToggle)}
      >
        {products.map(({ name }, index: number) => (
          <Segments.Tab key={`${name}-${index}`}>{name}</Segments.Tab>
        ))}
      </Segments.Tablist>
      {products.map((product: ProductInsuranceProps, index: number) => (
        <Segments.Panel key={`${product.name}-${index}`}>
          <div className={styles.header}>
            <Title as="h3" size="5" text={product.name} />
            <p>{product.uvp}</p>
          </div>
          <ul className={styles.features}>
            {features.map(function Row({ name, uniqueId, uvp }, index: number) {
              const [isExpanded, setExpand] = useState(false);
              const coverage = getCoverage(name, product);

              return (
                <li key={`${name}-${index}`}>
                  <button
                    aria-controls={`mobile-${uniqueId}`}
                    aria-expanded={isExpanded}
                    aria-disabled={!coverage.isCovered} // Hide not covered features for better VoiceOver-support
                    className={classNames(
                      styles.buttonReset,
                      styles.expander,
                      isExpanded && styles.isExpanded,
                      coverage.className
                    )}
                    onClick={() => setExpand(!isExpanded)}
                    type="button"
                  >
                    {coverage.icon}
                    <span role="text">
                      {name}
                      {coverage.text && ` (${coverage.text})`}
                    </span>
                    <Chevron open={isExpanded} />
                  </button>
                  <div
                    className={styles.expanderTarget}
                    hidden={!isExpanded}
                    id={`mobile-${uniqueId}`}
                  >
                    <div>
                      <div>{uvp}</div>
                    </div>
                  </div>
                </li>
              );
            })}
          </ul>
        </Segments.Panel>
      ))}
    </Segments>
  </div>
);
